import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { useToast } from '@/shared/hooks/useToast';
import { invitationsService } from '../api/members.service';
import { INVITATIONS_KEYS } from './queryKeys';

export function useCancelInvitation() {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;
  const { toast } = useToast();
  const { t } = useTranslation('members');

  return useMutation({
    mutationFn: (invitationId: string) => invitationsService.cancel(invitationId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: INVITATIONS_KEYS.byOrg(orgId) });
      toast.success({ title: t('invitations.cancelledToast') });
    },
  });
}
